/**
 * Constants for Accounts Mapbox Integration
 *
 * All constant values used across the accounts mapbox feature.
 */

import {
	ACCOUNT_STATUSES,
	ACTIVE,
	FAILED_INSTALL,
	IGNORE,
	INACTIVE,
	LEAD,
	OPPORTUNITY,
	PENDING_ACCEPTANCE,
	PENDING_INSTALL,
	PROSPECT
} from '@/constants/accounts/statuses'
import type { LngLatLike } from 'mapbox-gl'

// Re-export account status constants
export {
	ACCOUNT_STATUSES,
	ACTIVE,
	FAILED_INSTALL,
	IGNORE,
	INACTIVE,
	LEAD,
	OPPORTUNITY,
	PENDING_ACCEPTANCE,
	PENDING_INSTALL,
	PROSPECT
}

// =============================================================================
// Map Configuration
// =============================================================================

/** Unique ID for the accounts mapbox instance */
export const ACCOUNTS_MAPBOX_ID = 'accounts-mapbox'

/** Default map center coordinates (Denver, CO) */
export const DEFAULT_CENTER: LngLatLike = [ -104.7595, 39.5183 ]

/** Default map zoom level */
export const DEFAULT_ZOOM = 11

// =============================================================================
// Mainline Status Constants
// =============================================================================

export const PLANNED = 'planned'
export const COMPLETED = 'completed'
export const VERIFIED = 'verified'

export const MAINLINE_STATUSES = [ PLANNED, COMPLETED, VERIFIED ]

export const MAINLINE_STATUS_COLORS = {
	PLANNED: '#FE9900',
	COMPLETED: '#3A8B1B',
	VERIFIED: '#eefc08'
}

// =============================================================================
// Zone Type Constants
// =============================================================================

export const ZONE_TYPES: { [key: string]: string } = {
	EXTENDED: 'extended',
	IN_SERVICE: 'in_service'
}

// =============================================================================
// Source IDs
// =============================================================================

export const MARKERS_SOURCE_ID = 'service-locations-source'
export const ZONES_SOURCE_ID = 'zones-source'
export const MAINLINE_SOURCE_ID = 'mainlines-source'

// =============================================================================
// Layer IDs
// =============================================================================

export const MARKERS_LAYER_ID = 'service-locations-layer'
export const ZONES_LAYER_ID = 'zones-layer'
export const ZONES_LINE_LAYER_ID = 'zones-line-layer'
export const MAINLINE_MARKERS_LAYER_ID = 'mainline-handholes-layer'
export const MAINLINE_LINE_STRINGS_LAYER_ID = 'mainline-line-layer'

// =============================================================================
// Filter IDs
// =============================================================================

export const ACTIVE_ZONE_MARKER_FILTER_ID = 'active-zone-marker-filter'
export const ACTIVE_STATUS_MARKER_FILTER_ID = 'active-status-marker-filter'
export const HAS_EQUIPMENT_MARKER_FILTER_ID = 'has-equipment-marker-filter'
export const ACTIVE_ZONE_LINE_LAYER_FILTER_ID = 'active-zone-line-layer-filter'
export const ACTIVE_ZONE_FILL_LAYER_FILTER_ID = 'active-zone-fill-layer-filter'
export const TABLE_DATA_MARKER_FILTER_ID = 'table-data-marker-filter'
export const TABLE_FILTER_SYNC_ID = 'table-filter-sync'
